// extracted by mini-css-extract-plugin
export default {"root":"Comment_root__jHP3K","avatar":"Comment_avatar__hlL7Y","userInfo":"Comment_userInfo__kEo1k","content":"Comment_content__uYufg"};